// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BusinessInsights_bi__content__BYivx {
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .BusinessInsights_bi__content__BYivx {
    grid-template-columns: repeat(2, 1fr);
  }
}
.BusinessInsights_bi__income__siwtm {
  background-color: var(--color-green);
  color: var(--color-white);
  height: 12.5rem;
}
.BusinessInsights_bi__profit__Oj8dS {
  background-color: var(--color-yellow);
  height: 12.5rem;
}
.BusinessInsights_bi__credit__jrVAT {
  background-color: var(--color-primary-3);
  height: 12.5rem;
}
.BusinessInsights_bi__expenses__cv4WE {
  background-color: var(--color-light-red);
  height: 12.5rem;
}
.BusinessInsights_bi__sales__AGZ6t {
  background-color: var(--color-primary-7);
  height: 12.5rem;
}
.BusinessInsights_bi__health__rkJHQ {
  background-color: var(--color-green-2);
  height: 12.5rem;
}
.BusinessInsights_bi__info__rX42z {
  margin-top: 3rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1rem;
  cursor: pointer;
}
.BusinessInsights_bi__sideCards__9QtUT {
  display: grid;
  grid-template-columns: repeat(2, 49%);
  gap: 3rem;
  box-sizing: border-box;
  margin-top: 6rem;
}
@media only screen and (max-width: 56.25em) {
  .BusinessInsights_bi__sideCards__9QtUT {
    grid-template-columns: 80%;
    justify-content: center;
  }
}
@media only screen and (max-width: 31.25em) {
  .BusinessInsights_bi__sideCards__9QtUT {
    grid-template-columns: 100%;
  }
}
.BusinessInsights_bi__mainCards__T45IR {
  height: 45rem;
  width: 100%;
  box-sizing: border-box;
  padding: 4rem 2rem 2rem 2rem;
  background-color: var(--color-primary-3);
  border-radius: 2rem;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P {
  height: fit-content;
  min-height: 50rem;
  width: 100%;
  box-sizing: border-box;
  padding: 2rem;
  border-radius: 2rem;
  border: 2px solid var(--color-primary-2);
  position: relative;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P table {
  width: 100%;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P table tbody > :not(:last-child) {
  margin-bottom: 1rem;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P table tr {
  display: grid;
  grid-template-columns: 1fr 2fr;
}
.BusinessInsights_bi__mainCards_b__\\+pL9P table tr > :last-child {
  font-weight: 700;
  text-align: right;
}
.BusinessInsights_bi__mainCards__T45IR table {
  width: 100%;
}
.BusinessInsights_bi__mainCards__T45IR table tbody > :not(:last-child) {
  margin-bottom: 1rem;
}
.BusinessInsights_bi__mainCards__T45IR table tr {
  display: grid;
  grid-template-columns: 1fr 13fr 2fr;
}
.BusinessInsights_bi__mainCards__T45IR table tr > :last-child {
  font-weight: 700;
}

.BusinessInsights_card_top__kMUi4 {
  display: flex;
  justify-content: space-between;
  margin: 2rem 0;
}
@media only screen and (max-width: 37.5em) {
  .BusinessInsights_card_top__kMUi4 {
    font-size: var(--default-font-small);
  }
}
.BusinessInsights_card_top_icon__R7p8l {
  display: flex;
}
.BusinessInsights_card_top_icon__R7p8l > :first-child {
  margin-right: 1rem;
}
.BusinessInsights_card_top_filter__eFqqJ {
  display: flex;
}
.BusinessInsights_card_top_filter__eFqqJ > :first-child {
  margin-right: 3rem;
}
.BusinessInsights_card_top_pie__OuTpT {
  width: 100%;
}
.BusinessInsights_card_bottom__qXjE3 {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  margin-top: 1rem;
}
.BusinessInsights_card_bottom__qXjE3 > :not(:last-child) {
  margin-right: 1rem;
}
.BusinessInsights_card_bottom_content__KpDGe {
  display: flex;
  align-items: center;
  font-size: var(--default-font-small);
}
.BusinessInsights_card_bottom_content__KpDGe img {
  height: 1.5rem;
  margin-right: 1rem;
}

.BusinessInsights_modalTable__Bvu7v table {
  width: 40rem;
}
.BusinessInsights_modalTable__Bvu7v table tbody > :not(:last-child) {
  margin-bottom: 2rem;
}
.BusinessInsights_modalTable__Bvu7v table tr {
  display: grid;
  grid-template-columns: 7fr 3fr;
}
.BusinessInsights_modalTable__Bvu7v table tr > :last-child {
  font-weight: 700;
}

.BusinessInsights_modalInfo__Smo1j {
  font-size: 3rem;
  color: var(--color-primary);
  position: relative;
  left: 20rem;
  margin-top: 3rem;
}

.BusinessInsights_terms__pAwNK {
  width: 40rem;
}
.BusinessInsights_terms__pAwNK span {
  font-weight: 700;
  color: var(--color-primary);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/BusinessInsights/BusinessInsights.module.scss"],"names":[],"mappings":"AAGC;EACC,aAAA;EACA,sBAAA;EACA,qCAAA;EACA,SAAA;AAFF;AAIE;EAND;IAOE,qCAAA;EADD;AACF;AAIC;EACC,oCAAA;EACA,yBAAA;EACA,eAAA;AAFF;AAKC;EACC,qCAAA;EACA,eAAA;AAHF;AAMC;EACC,wCAAA;EACA,eAAA;AAJF;AAOC;EACC,wCAAA;EACA,eAAA;AALF;AAQC;EACC,wCAAA;EACA,eAAA;AANF;AASC;EACC,sCAAA;EACA,eAAA;AAPF;AAUC;EACC,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AARF;AAWC;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;AATF;AAWE;EAPD;IAQE,0BAAA;IACA,uBAAA;EARD;AACF;AAUE;EAZD;IAaE,2BAAA;EAPD;AACF;AAUC;EACC,aAAA;EACA,WAAA;EACA,sBAAA;EACA,4BAAA;EACA,wCAAA;EACA,mBAAA;AARF;AAUE;EACC,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,kBAAA;AARH;AASG;EACC,WAAA;AAPJ;AASK;EACC,mBAAA;AAPN;AAWI;EACC,aAAA;EACA,8BAAA;AATL;AAWK;EACC,gBAAA;EACA,iBAAA;AATN;AAeE;EACC,WAAA;AAbH;AAeI;EACC,mBAAA;AAbL;AAiBG;EACC,aAAA;EACA,mCAAA;AAfJ;AAiBI;EACC,gBAAA;AAfL;;AAuBC;EACC,aAAA;EACA,8BAAA;EACA,cAAA;AApBF;AAsBE;EALD;IAME,oCAAA;EAnBD;AACF;AAqBE;EACC,aAAA;AAnBH;AAoBG;EACC,kBAAA;AAlBJ;AAsBE;EACC,aAAA;AApBH;AAqBG;EACC,kBAAA;AAnBJ;AAuBE;EACC,WAAA;AArBH;AAyBC;EACC,aAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AAvBF;AAwBE;EACC,kBAAA;AAtBH;AAyBE;EACC,aAAA;EACA,mBAAA;EACA,oCAAA;AAvBH;AAyBG;EACC,cAAA;EACA,kBAAA;AAvBJ;;AA8BC;EACC,YAAA;AA3BF;AA6BG;EACC,mBAAA;AA3BJ;AA+BE;EACC,aAAA;EACA,8BAAA;AA7BH;AA+BG;EACC,gBAAA;AA7BJ;;AAmCA;EACC,eAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAhCD;;AAmCA;EACC,YAAA;AAhCD;AAiCC;EACC,gBAAA;EACA,2BAAA;AA/BF","sourcesContent":["@import '../variables/breakpoints';\n\n.bi {\n\t&__content {\n\t\tdisplay: grid;\n\t\tbox-sizing: border-box;\n\t\tgrid-template-columns: repeat(3, 1fr);\n\t\tgap: 2rem;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t}\n\t}\n\n\t&__income {\n\t\tbackground-color: var(--color-green);\n\t\tcolor: var(--color-white);\n\t\theight: 12.5rem;\n\t}\n\n\t&__profit {\n\t\tbackground-color: var(--color-yellow);\n\t\theight: 12.5rem;\n\t}\n\n\t&__credit {\n\t\tbackground-color: var(--color-primary-3);\n\t\theight: 12.5rem;\n\t}\n\n\t&__expenses {\n\t\tbackground-color: var(--color-light-red);\n\t\theight: 12.5rem;\n\t}\n\n\t&__sales {\n\t\tbackground-color: var(--color-primary-7);\n\t\theight: 12.5rem;\n\t}\n\n\t&__health {\n\t\tbackground-color: var(--color-green-2);\n\t\theight: 12.5rem;\n\t}\n\n\t&__info {\n\t\tmargin-top: 3rem;\n\t\tdisplay: flex;\n\t\tjustify-content: flex-end;\n\t\talign-items: center;\n\t\tgap: 1rem;\n\t\tcursor: pointer;\n\t}\n\n\t&__sideCards {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(2, 49%);\n\t\tgap: 3rem;\n\t\tbox-sizing: border-box;\n\t\tmargin-top: 6rem;\n\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\tgrid-template-columns: 80%;\n\t\t\tjustify-content: center;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tgrid-template-columns: 100%;\n\t\t}\n\t}\n\n\t&__mainCards {\n\t\theight: 45rem;\n\t\twidth: 100%;\n\t\tbox-sizing: border-box;\n\t\tpadding: 4rem 2rem 2rem 2rem;\n\t\tbackground-color: var(--color-primary-3);\n\t\tborder-radius: 2rem;\n\n\t\t&_b {\n\t\t\theight: fit-content;\n\t\t\tmin-height: 50rem;\n\t\t\twidth: 100%;\n\t\t\tbox-sizing: border-box;\n\t\t\tpadding: 2rem;\n\t\t\tborder-radius: 2rem;\n\t\t\tborder: 2px solid var(--color-primary-2);\n\t\t\tposition: relative;\n\t\t\ttable {\n\t\t\t\twidth: 100%;\n\t\t\t\ttbody {\n\t\t\t\t\t& > :not(:last-child) {\n\t\t\t\t\t\tmargin-bottom: 1rem;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\ttr {\n\t\t\t\t\tdisplay: grid;\n\t\t\t\t\tgrid-template-columns: 1fr 2fr;\n\n\t\t\t\t\t& > :last-child {\n\t\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\t\ttext-align: right;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\ttable {\n\t\t\twidth: 100%;\n\t\t\ttbody {\n\t\t\t\t& > :not(:last-child) {\n\t\t\t\t\tmargin-bottom: 1rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\ttr {\n\t\t\t\tdisplay: grid;\n\t\t\t\tgrid-template-columns: 1fr 13fr 2fr;\n\n\t\t\t\t& > :last-child {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.card {\n\t&_top {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tmargin: 2rem 0;\n\n\t\t@media only screen and (max-width: $bp-600) {\n\t\t\tfont-size: var(--default-font-small);\n\t\t}\n\n\t\t&_icon {\n\t\t\tdisplay: flex;\n\t\t\t& > :first-child {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&_filter {\n\t\t\tdisplay: flex;\n\t\t\t& > :first-child {\n\t\t\t\tmargin-right: 3rem;\n\t\t\t}\n\t\t}\n\n\t\t&_pie {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t&_bottom {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t\tmargin-top: 1rem;\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t&_content {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\timg {\n\t\t\t\theight: 1.5rem;\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.modalTable {\n\ttable {\n\t\twidth: 40rem;\n\t\ttbody {\n\t\t\t& > :not(:last-child) {\n\t\t\t\tmargin-bottom: 2rem;\n\t\t\t}\n\t\t}\n\n\t\ttr {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 7fr 3fr;\n\n\t\t\t& > :last-child {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.modalInfo {\n\tfont-size: 3rem;\n\tcolor: var(--color-primary);\n\tposition: relative;\n\tleft: 20rem;\n\tmargin-top: 3rem;\n}\n\n.terms {\n\twidth: 40rem;\n\tspan {\n\t\tfont-weight: 700;\n\t\tcolor: var(--color-primary);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bi__content": `BusinessInsights_bi__content__BYivx`,
	"bi__income": `BusinessInsights_bi__income__siwtm`,
	"bi__profit": `BusinessInsights_bi__profit__Oj8dS`,
	"bi__credit": `BusinessInsights_bi__credit__jrVAT`,
	"bi__expenses": `BusinessInsights_bi__expenses__cv4WE`,
	"bi__sales": `BusinessInsights_bi__sales__AGZ6t`,
	"bi__health": `BusinessInsights_bi__health__rkJHQ`,
	"bi__info": `BusinessInsights_bi__info__rX42z`,
	"bi__sideCards": `BusinessInsights_bi__sideCards__9QtUT`,
	"bi__mainCards": `BusinessInsights_bi__mainCards__T45IR`,
	"bi__mainCards_b": `BusinessInsights_bi__mainCards_b__+pL9P`,
	"card_top": `BusinessInsights_card_top__kMUi4`,
	"card_top_icon": `BusinessInsights_card_top_icon__R7p8l`,
	"card_top_filter": `BusinessInsights_card_top_filter__eFqqJ`,
	"card_top_pie": `BusinessInsights_card_top_pie__OuTpT`,
	"card_bottom": `BusinessInsights_card_bottom__qXjE3`,
	"card_bottom_content": `BusinessInsights_card_bottom_content__KpDGe`,
	"modalTable": `BusinessInsights_modalTable__Bvu7v`,
	"modalInfo": `BusinessInsights_modalInfo__Smo1j`,
	"terms": `BusinessInsights_terms__pAwNK`
};
export default ___CSS_LOADER_EXPORT___;
